import dayjs from "dayjs";
import { useManagementSubscriptionContext } from "./Context";
import CloseModalIcon from "../../shared-components/icons/CloseModalIcon";

const removeRenewParam = () => {
  const url = new URL(window.location.href);
  if (url.searchParams.has("renew")) {
    url.searchParams.delete("renew");
    window.history.replaceState({}, "", url.pathname + url.search);
  }
};

const CancelSubscription = () => {
  const {
    setShouldShowCancelSubscriptionStep,
    subsWillBeCancelled,
    activePricePlan,
    subscriptionPlan,
    isButtonDisabled,
    onRenewSubscription,
    onCancelSubscription,
    onCancelSubscriptionModal,
  } = useManagementSubscriptionContext();

  const handleDismiss = () => {
    removeRenewParam();
    setShouldShowCancelSubscriptionStep(false);
  };

  return (
    <div>
      <div data-name="Overlay" className="fixed inset-0 z-[9999] bg-black/80" />
      <div
        data-name="PopupContainer"
        className={"fixed inset-0 z-[99999] w-full min-h-full overflow-x-hidden overflow-y-auto"}>
        <div className={"w-full min-h-full flex-center flex-col m-auto"}>
          <div
            className={
              "bg-white relative w-full lg:max-w-[1000px] lg:min-h-[614px] px-4 pt-10 pb-3 lg:px-14 lg:pb-6 flex flex-col max-lg:grow lg:rounded-2xl"
            }>
            <button
              onClick={handleDismiss}
              className={"absolute flex items-center justify-center right-3 top-3 lg:right-4 lg:top-4 lg:size-10"}>
              <CloseModalIcon className={"size-6 text-gray-5"} />
            </button>

            {/*title*/}
            <div className="font-jost text-xl font-semibold text-center leading-6.5 mb-6 lg:text-2xl lg:leading-7.5 lg:mb-8">
              {subsWillBeCancelled ? "Renew your subscription" : "Cancel your subscription"}
            </div>

            {/*GRAY WRAPPER START*/}
            <div className={"bg-gray-4 rounded-lg p-4 mb-4 lg:px-6 lg:max-w-[480px] lg:mx-auto"}>
              <div className={"text-xs text-gray-1 leading-4 uppercase font-normal lg:text-sm lg:leading-5"}>
                Current subscription
              </div>
              <hr className="my-2 lg:my-4" />
              {/*CONTENT*/}
              <div className="min-h-28">
                <div className={"lg:max-w-[464px]"}>
                  <div className="text-gray-1 text-base font-medium leading-5.5 mb-1 font-jost lg:text-lg lg:leading-6 lg:mb-2">
                    {subscriptionPlan.name}
                  </div>
                  <div className="text-gray-1 text-base font-medium leading-5.5 mb-2 lg:text-sm lg:mb-4">
                    <span className="text-dark-1 font-jost text-[28px] leading-8 font-bold lg:text-[32px] lg:leading-10">
                      £{activePricePlan.unit_amount / 100}
                    </span>{" "}
                    /{subscriptionPlan.interval}
                  </div>
                  <div className="text-sm text-secondary font-jost font-normal leading-5 lg:text-sm">
                    {subsWillBeCancelled
                      ? "Your subscription will no longer be cancelled. It will renew on"
                      : "Your subscription will be cancelled, but is still available until the end of your billing period on"}{" "}
                    <span className={"text-dark-1 font-medium"}>
                      {dayjs(subscriptionPlan.current_period_end * 1000).format("DD MMMM YYYY")}
                    </span>
                    .
                  </div>

                  {!subsWillBeCancelled && (
                    <div className="text-sm text-secondary font-jost font-normal leading-5">
                      If you change your mind, you can renew your subscription.
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/*GRAY WRAPPER END*/}

            {/*TC*/}
            <div className={"lg:max-w-[480px] lg:mx-auto"}>
              {subsWillBeCancelled && (
                <div className="text-gray-5 font-jost text-[11px] font-normal leading-3.5 lg:text-xs lg:leading-4.5">
                  By renewing your subscription, you maintain your consent for recurring billing and for subscription
                  conditions, in accordance with BOTB{" "}
                  <a
                    target="_blank"
                    href="https://www.botb.com/terms"
                    title={"Terms of Service"}
                    className={"!underline text-primary"}>
                    Terms and Conditions
                  </a>{" "}
                  and{" "}
                  <a
                    target="_blank"
                    href="https://www.botb.com/privacy"
                    title={"Privacy Policy"}
                    className={"!underline text-primary"}>
                    Privacy Policy
                  </a>
                </div>
              )}
            </div>

            {/*buttons*/}
            <div className={"flex max-lg:flex-col gap-2 lg:justify-end mt-auto"}>
              <button
                disabled={isButtonDisabled}
                onClick={subsWillBeCancelled ? onRenewSubscription : onCancelSubscription}
                className={
                  "theme-btn theme-btn-primary theme-btn-md uppercase max-lg:w-full lg:order-2 lg:min-w-[220px]"
                }>
                {subsWillBeCancelled ? "Renew subscription" : "Cancel subscription"}
              </button>
              <button
                onClick={handleDismiss}
                className={"theme-btn theme-btn-md uppercase max-lg:w-full text-primary lg:order-1"}>
                Go back
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancelSubscription;
